<template>
  <div v-wechat-title="cateName" class="classify-page">
    <div class="content-box">
      <div class="box1">
        <search :data="keyword" @search="onSearch"></search>
      </div>
      <van-image v-if="adsImage" :src="adsImage" height="100" lazy-load></van-image>
      <MallSortTable ref="list" :cate-id="cateId" :keyword="keyword" :searchType="searchType"
        :include-cate-ids="includeCateIds" :exclude-cate-ids="excludeCateIds" />
    </div>
    <PageFooter :active="activeId"></PageFooter>
  </div>
</template>

<script>
import Vue from "vue";
import { api_get_cate_by_id } from "@/api/goods-api";
import GoodsUnit from "@/components/common/goods-unit";
import { Lazyload } from "vant";
import MallSortTable from "@/components/common/MallSortTable";
import PageFooter from "@/components/common/page-footer";

Vue.use(Lazyload);

export default {
  name: "goods-list",
  components: { PageFooter, MallSortTable, GoodsUnit },
  data() {
    return {
      keyword: "",
      goodsList: [],
      cateId: 1,
      adsImage: "",
      cateName: "",
      searchType: "", // 1-是从citySelect组件点击搜索跳转到此页面
      activeId: 0,
      includeCateIds: '',
      excludeCateIds: ''
    };
  },
  created() {
    this.cateId = Number(this.$route.query.cateId) || 0;
    if (this.cateId === 3) {
      this.activeId = 1;
    } else if (this.cateId === 4) {
      this.activeId = 3;
    }

    this.searchType = this.$route.query.searchType;
    this.keyword = this.$route.query.value;
    this.includeCateIds = this.$route.query.includeCateIds;
    this.excludeCateIds = this.$route.query.excludeCateIds;

    this.$nextTick(() => {
      if (this.$route.query.value) {
        this.onSearch(this.keyword);
      }
    });

    api_get_cate_by_id(this.cateId).then((res) => {
      if (res.data) {
        this.cateName = res.data.name;
        this.adsImage = res.data.adsImage;
      }
    });
  },

  methods: {
    onSearch(val) {
      this.$refs.list.search(val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
